import { FormattedMessage, useIntl } from 'react-intl';
import React from 'react';
import { useModal } from 'store/modals';
import { useDeleteGroup } from 'services/2n/groups/delete-group';
import { DeleteButton } from 'components/form-elements/buttons/DeleteButton';
import { useAccessManagement2NModal } from '../../../AccessManagement2NModalContext/useAccessManagement2NModal';
import styles from './styles.module.scss';

export const DeleteGroup = () => {

  const intl = useIntl();
  const { openModal } = useModal();
  const { selected, updateSelected } = useAccessManagement2NModal();
  const selectedGroup = selected.group;
  const { deleteGroupAsync, isLoading } = useDeleteGroup();

  function onDeleteGroup() {
    if (!selectedGroup) return;
    openModal({
      modalType: 'ConfirmationModal',
      modalProps: {
        title: intl.formatMessage(
          {
            id: 'deleteGroupConfirm',
          },
        ),
        content: intl.formatMessage(
          {
            id: 'accessGroupsDeleteConfirmContent',
          },
        ),
        onConfirm: async () => {
          await deleteGroupAsync(selectedGroup.Id);
          updateSelected('group', null);
        },
      },
    });
  }

  return (

    <DeleteButton
      className={styles.deleteButton}
      intl="accessGroupsDeletePermanently"
      onClick={() => onDeleteGroup()}
      disabled={!selectedGroup || isLoading}
    >
      <FormattedMessage id="accessGroupsDeletePermanently" />
    </DeleteButton>
   
  );
};
